/*
 * @providesModule MatchStore
 */

import MinFlux from 'min-flux';
import RESTStore from 'RESTStore';


import {
  NativeModules,
  Platform,
} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

const MatchStore = new MinFlux.Store({
  getData() {
    return this._data || null;
  },

  fetchMatch(matchId, userId, shouldFailSilently, completion) {
    // Guard against undefined/null parameters to prevent malformed URLs
    if (!matchId || !userId) {
      console.warn(
        `MatchStore.fetchMatch: Invalid parameters - matchId: ${matchId}, userId: ${userId}. Skipping API request.`
      );
      if (completion) {
        completion(null, new Error(`Invalid parameters: matchId=${matchId}, userId=${userId}`));
      }
      return;
    }

    const retryPrompt = shouldFailSilently === true ? SKZAPIManager.OnError.failSilently : (Platform.OS == 'android' ? true : SKZAPIManager.OnError.promptRetry);
    
    // Dynamically get user path selection from FTUEController
    const FTUEController = require('FTUEController').default;
    const userPathSelection = FTUEController.getUserPathSelection();
    
    // Build API URL: only add query parameter if user has made a selection
    let apiUrl = 'users/' + userId + '/matches/' + matchId;
    if (userPathSelection) {
      const userPath = userPathSelection.toLowerCase();
      apiUrl = 'users/' + userId + '/matches/' + matchId + '?new_user_path=' + userPath;
      console.debug(`MatchStore.fetchMatch: Fetching match with user_path=${userPath}`);
    } else {
      console.debug('MatchStore.fetchMatch: Fetching match without user_path parameter (no selection yet)');
    }
    
    RESTStore.getServerResponse(apiUrl,
      null,
      retryPrompt,
      (response, error) => {
        completion(response, error);
      });
  },

  // same as fetchMatch except for retry mode, this fails silently
  fetchMatchForChatMessage(matchId, userId, completion) {
    // Guard against undefined/null parameters to prevent malformed URLs
    if (!matchId || !userId) {
      console.warn(
        `MatchStore.fetchMatchForChatMessage: Invalid parameters - matchId: ${matchId}, userId: ${userId}. Skipping API request.`
      );
      if (completion) {
        completion(null, new Error(`Invalid parameters: matchId=${matchId}, userId=${userId}`));
      }
      return;
    }

    const retryPrompt = SKZAPIManager.OnError.failSilently;
    
    // Dynamically get user path selection from FTUEController
    const FTUEController = require('FTUEController').default;
    const userPathSelection = FTUEController.getUserPathSelection();
    
    // Build API URL: only add query parameter if user has made a selection
    let apiUrl = 'users/' + userId + '/matches/' + matchId;
    if (userPathSelection) {
      const userPath = userPathSelection.toLowerCase();
      apiUrl = 'users/' + userId + '/matches/' + matchId + '?new_user_path=' + userPath;
      console.debug(`MatchStore.fetchMatchForChatMessage: Fetching match with user_path=${userPath}`);
    } else {
      console.debug('MatchStore.fetchMatchForChatMessage: Fetching match without user_path parameter (no selection yet)');
    }
    
    RESTStore.getServerResponse(apiUrl,
      null,
      retryPrompt,
      (response, error) => {
        completion(response, error);
      });
  },

  actionTypeHandlers: {
    FETCH_MATCH(action) {
      this.fetchMatch(
        action.payload.matchID,
        action.payload.userID,
        (response, error) => {
          this._data = response;
          this.emitChange();
        }
      );
    },
  },

});

export default MatchStore;
